import { uploadDocumentsActions } from "./UploadDocumentsAction";

const initialState = {
  uploadLoading: false,
  uploadData: "",
  uploadError: "",
};

const UploadDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case uploadDocumentsActions.UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadData: action.payload,
        uploadLoading: false,
      };

    case uploadDocumentsActions.UPLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        uploadError: action.payload,
        uploadLoading: false,
      };

    case uploadDocumentsActions.UPLOAD_DOCUMENT_LOADING:
      return {
        ...state,
        uploadLoading: true,
      };

    default:
      return state;
  }
};

export default UploadDocumentsReducer;
